import React from "react";
import { Vehicle } from "@/types";
import { formatUserName } from "@/utils/userName";

interface VehicleCardProps {
  vehicle: Vehicle;
  onView: (vehicle: Vehicle) => void;
}

export const VehicleCard: React.FC<VehicleCardProps> = ({
  vehicle,
  onView,
}) => {
  const title = vehicle.name || `${vehicle.year} ${vehicle.maker} ${vehicle.model}`;
  const subtitle = vehicle.name
    ? `${vehicle.year} ${vehicle.maker} ${vehicle.model}`
    : vehicle.description;

  return (
    <div className="bg-white rounded-lg border border-secondary-200 px-4 py-3 sm:px-5 sm:py-3.5">
      {/* Row 1: Title */}
      <div className="min-w-0">
        <button
          className="text-base font-semibold text-secondary-900 cursor-pointer hover:text-primary-600 transition-colors truncate text-left block w-full"
          onClick={() => onView(vehicle)}
        >
          {title}
        </button>
      </div>

      {/* Row 2: Inline metadata */}
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-1.5 text-sm text-secondary-500">
        {subtitle && <span className="truncate">{subtitle}</span>}
        {vehicle.user && (
          <>
            {subtitle && <span className="text-secondary-400">·</span>}
            <span>
              {formatUserName(vehicle.user)}
            </span>
          </>
        )}
      </div>
    </div>
  );
};
